/*
 * @Author: K
 * @Date: 2022-04-09 16:22:30
 * @LastEditors: owen
 * @LastEditTime: 2022-04-09 16:22:31
 * @FilePath: \app-pcweb\src\utils\img.js
 */
/*
 * @Author: owen
 * @Date: 2022-03-23 18:51:23
 * @LastEditors: owen
 * @LastEditTime: 2022-03-31 14:43:09
 * @Description: file content
 * @FilePath: \app-h5web\src\utils\img.js
 */

// 1(hashchain): "哈希链",2(hashtime): "哈希时间戳",3(hash): "哈希加密",4(binance): "币安哈希",5: "常规",6(tron): "波场",
export function gameImg(data) {
  const gameSrc = {
    hashchain: require("@/assets/game/4.png"),
    hashtime: require("@/assets/game/2.png"),
    hash: require("@/assets/game/1.png"),
    binance: require("@/assets/game/3.png"),
    tron: require("@/assets/game/5.png"),
  };

  //   const gameSrc = {
  //     1: require("@/assets/game/4.png"),
  //     2: require("@/assets/game/2.png"),
  //     3: require("@/assets/game/1.png"),
  //     4: require("@/assets/game/3.png"),
  //   };
  if (data) {
    // const idstr = data.gameGroupSid.toString();
    // let type = 0;
    // // slot 和 其他游戏取倒数第二位作为 作为游戏玩法

    // // if (/^(game_)?(1|3)[0-9]+$/.test(idstr)) {
    // //   type = Number(idstr[idstr.length - 2]);
    // // } else if (/^(game_)?2[0-9]+$/.test(idstr)) {
    // //   // 捕猎取倒数第四 作为游戏玩法
    // //   type = Number(idstr[idstr.length - 4]);
    // // }

    // // if (/^(game_)?2[0-9]{6}$/.test(idstr)) {
    // //   // 老捕猎
    // //   // 捕猎取倒数第四 作为游戏玩法
    // //   type = Number(idstr[idstr.length - 4]);
    // // } else {
    // //   // 其他
    // //   type = Number(idstr[idstr.length - 2]);
    // // }
    // type = Number(idstr[idstr.length - 2]);

    // if (type !== 0) {
    //   // console.log(gameSrc[type], " gameSrc[type]");
    //   return gameSrc[type];
    // } else {
    //   return 0;
    // }

    const type = data.gamePlayTypeKey
    if (type && gameSrc[type]) {
      return gameSrc[type];
    } else {
      return 0;
    }
  }

  // return data;
}
